var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _circle, _circle2, _rect7, _rect8, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetailedAnalysis = function SvgDetailedAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.814 1.189c24.391-5.169 50.34 7.35 69.037 21.42 17.659 13.288 22.91 33.561 29.405 52.66 6.234 18.335 12.203 36.816 7.355 55.44-5.217 20.043-15.948 39.714-35.386 52.245-19.736 12.724-45.934 19.911-70.411 15.963-22.91-3.696-35-23.568-53.088-35.883-16.691-11.364-38.392-17.619-48.695-33.414C4.48 111.915-6.724 89.01 4.915 71.346 16.679 53.49 50.687 59.478 70.262 47.314 90.239 34.9 93.68 6.303 117.814 1.189Z",
    fill: "url(#detailed-analysis_svg__a)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.925 55.185c0-.796.002-1.824.918-2.735.916-.912 1.944-.912 2.744-.912h155.75c1.374 0 2.033.2 2.748.912.715.712.914 1.728.914 2.735v91.168c.002.912-.199 2.023-.914 2.735-.715.712-1.374.912-2.748.912H40.592c-1.132 0-2.022-.188-2.749-.912-.918-.915-.918-2.735-.918-2.735s-.003-66.119 0-91.168Zm158.46.864H41.539v89.561h153.846V56.049Z",
    fill: "#0550AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.976 152.734h33.897v13.676c0 .911 2.744 3.19 2.744 3.19l4.127 3.227c.749.586.335 1.788-.616 1.788H95.713c-.951 0-1.365-1.202-.616-1.788l4.126-3.227s2.753-2.279 2.753-3.646v-13.22Z",
    fill: "#0550AA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 120.667,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 113.193,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 105.718,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 98.245,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 90.771,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.431,
    y: 83.298,
    width: 3.737,
    height: 0.862,
    rx: 0.431,
    fill: "#011626",
    stroke: "#011626",
    strokeWidth: 0.862
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m93.846 109.356 7.626-7.091a3 3 0 0 1 4.086 0l7.929 7.373a3 3 0 0 0 4.086 0l17.811-16.562",
    stroke: "#2096F3",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.077,
    cy: 110,
    r: 2.077,
    fill: "#fff",
    stroke: "#2096F3",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.155,
    cy: 92.307,
    r: 2.077,
    fill: "#fff",
    stroke: "#2096F3",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.576,
    y: 78.192,
    width: 1.308,
    height: 54.385,
    rx: 0.654,
    fill: "#011626",
    stroke: "#011626"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 157.193,
    y: 128.962,
    width: 1.308,
    height: 76.692,
    rx: 0.654,
    transform: "rotate(90 157.193 128.962)",
    fill: "#011626",
    stroke: "#011626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.684 122.534h8.624a.574.574 0 1 0 0-1.15h-8.624a.574.574 0 0 0 0 1.15ZM140.572 118.51h11.183a.581.581 0 0 0 .589-.575.581.581 0 0 0-.589-.575h-11.183a.582.582 0 0 0-.589.575c0 .318.264.575.589.575ZM135.978 114.486h7.723a.584.584 0 0 0 .594-.575.584.584 0 0 0-.594-.574h-7.723a.584.584 0 0 0-.594.574c0 .318.266.575.594.575ZM144.295 110.461h4.025a.574.574 0 1 0 0-1.15h-4.025a.574.574 0 1 0 0 1.15Z",
    fill: "#011626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "detailed-analysis_svg__a",
    x1: 225.385,
    y1: 76.984,
    x2: 137.001,
    y2: 215.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39F",
    stopOpacity: 0.1
  })))));
};
export { SvgDetailedAnalysis as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='226' height='200' viewBox='0 0 226 200' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M117.814 1.18899C142.205 -3.9796 168.154 8.53832 186.851 22.6084C204.51 35.8975 209.761 56.17 216.256 75.2698C222.49 93.6038 228.459 112.085 223.611 130.709C218.394 150.752 207.663 170.423 188.225 182.954C168.489 195.678 142.291 202.865 117.814 198.917C94.9033 195.221 82.8137 175.349 64.7261 163.034C48.0347 151.67 26.3343 145.415 16.0305 129.62C4.48106 111.915 -6.72414 89.0096 4.91454 71.3457C16.6791 53.4907 50.6866 59.4778 70.2616 47.3137C90.239 34.8995 93.6796 6.30295 117.814 1.18899Z' fill='url(%23paint0_linear)' fill-opacity='0.1'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M36.9254 55.1847C36.9255 54.3886 36.9272 53.3614 37.8434 52.4498C38.7595 51.5381 39.7866 51.5381 40.5866 51.5381C81.1015 51.5384 194.962 51.5385 196.337 51.5385C197.711 51.5385 198.37 51.7378 199.085 52.4498C199.8 53.1618 199.999 54.1781 199.999 55.1848C199.999 56.8604 199.999 61.8064 199.999 68.5851C199.999 94.1132 199.998 145.633 199.999 146.353C200.001 147.265 199.8 148.376 199.085 149.088C198.37 149.8 197.711 150 196.337 150H40.5918C39.4604 150 38.5701 149.812 37.8434 149.088C36.9253 148.173 36.9253 146.353 36.9253 146.353C36.9253 146.353 36.922 80.234 36.9254 55.1847ZM195.385 56.0488H41.5387V145.61H195.385V56.0488Z' fill='%230550AA'/%3E %3Cpath d='M101.976 152.734H135.873V163.675C135.873 163.675 135.873 164.586 135.873 166.41C135.873 167.321 138.617 169.6 138.617 169.6L142.744 172.827C143.493 173.413 143.079 174.615 142.128 174.615H95.7128C94.7619 174.615 94.3478 173.413 95.0968 172.827L99.223 169.6C99.223 169.6 101.976 167.321 101.976 165.954C101.976 164.586 101.976 163.675 101.976 163.675V152.734Z' fill='%230550AA'/%3E %3Crect x='80.4312' y='120.667' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Crect x='80.4312' y='113.193' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Crect x='80.4312' y='105.718' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Crect x='80.4312' y='98.2447' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Crect x='80.4312' y='90.771' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Crect x='80.4312' y='83.2984' width='3.73684' height='0.862348' rx='0.431174' fill='%23011626' stroke='%23011626' stroke-width='0.862348'/%3E %3Cpath d='M93.8457 109.356L101.472 102.265C102.624 101.194 104.407 101.194 105.558 102.265L113.487 109.638C114.639 110.709 116.422 110.709 117.573 109.638L135.384 93.0762' stroke='%232096F3' stroke-width='2'/%3E %3Ccircle cx='93.0769' cy='110' r='2.07692' fill='white' stroke='%232096F3' stroke-width='2'/%3E %3Ccircle cx='136.155' cy='92.3074' r='2.07692' fill='white' stroke='%232096F3' stroke-width='2'/%3E %3Crect x='83.5762' y='78.1924' width='1.30769' height='54.3846' rx='0.653846' fill='%23011626' stroke='%23011626'/%3E %3Crect x='157.193' y='128.962' width='1.3077' height='76.6923' rx='0.653848' transform='rotate(90 157.193 128.962)' fill='%23011626' stroke='%23011626'/%3E %3Cpath d='M137.684 122.534L146.308 122.534C146.626 122.534 146.883 122.277 146.883 121.959C146.883 121.641 146.626 121.384 146.308 121.384L137.684 121.384C137.367 121.384 137.11 121.641 137.11 121.959C137.11 122.277 137.367 122.534 137.684 122.534Z' fill='%23011626'/%3E %3Cpath d='M140.572 118.51L151.755 118.51C152.081 118.51 152.344 118.253 152.344 117.935C152.344 117.617 152.081 117.36 151.755 117.36L140.572 117.36C140.247 117.36 139.983 117.617 139.983 117.935C139.983 118.253 140.247 118.51 140.572 118.51Z' fill='%23011626'/%3E %3Cpath d='M135.978 114.486L143.701 114.486C144.029 114.486 144.295 114.229 144.295 113.911C144.295 113.594 144.029 113.337 143.701 113.337L135.978 113.337C135.65 113.337 135.384 113.594 135.384 113.911C135.384 114.229 135.65 114.486 135.978 114.486Z' fill='%23011626'/%3E %3Cpath d='M144.295 110.461L148.32 110.461C148.638 110.461 148.895 110.204 148.895 109.886C148.895 109.568 148.638 109.311 148.32 109.311L144.295 109.311C143.977 109.311 143.72 109.568 143.72 109.886C143.72 110.204 143.977 110.461 144.295 110.461Z' fill='%23011626'/%3E %3Cdefs%3E %3ClinearGradient id='paint0_linear' x1='225.385' y1='76.9841' x2='137.001' y2='215.51' gradientUnits='userSpaceOnUse'%3E %3Cstop stop-color='%233399FF'/%3E %3Cstop offset='1' stop-color='%233399FF' stop-opacity='0.1'/%3E %3C/linearGradient%3E %3C/defs%3E %3C/svg%3E";